import {
  validateSeoTitle,
  validateSeoLongDescription
} from "@/src-refactor/modules/shared/helpers/text-validation.helper";
import { array, string } from "yup";

const seoStepSchema = {
  // seo

  seo_title_en_property: string()
    .default("")
    .label("Título SEO en inglés")
    .required("El título SEO en inglés es requerido")
    .test(
      "seo-title",
      "El título SEO en inglés debe tener máximo 60 caracteres",
      (val?: string | null) => !val || validateSeoTitle(val)
    ),
  seo_short_description_en_property: string()
    .label("Descripción corta SEO en inglés")
    // .required("La descripción corta SEO en inglés es requerida")
    // .max(161, "La descripción corta SEO en inglés debe tener máximo 160 caracteres")
    .default(""),
  seo_description_en_property: string()
    .default("")
    .label("Descripción SEO en inglés")
    .required("La descripción SEO en inglés es requerida")
    .test(
      "seo-description",
      "La descripción SEO en inglés debe tener entre 49-300 palabras y 200-2000 caracteres",
      (val?: string | null) => !val || validateSeoLongDescription(val)
    ),
  seo_keywords_en_property: array()
    .of(
      string()
      // .required("Las palabras clave SEO en español son requeridas")
    )
    .default([]),
  // .label("Palabras clave SEO en inglés")
  // .required("Las palabras clave SEO en inglés son requeridas"),
  seo_title_es_property: string()
    .default("")
    .label("Título SEO en español")
    .required("El título SEO en español es requerido")
    .test(
      "seo-title",
      "El título SEO en español debe tener máximo 60 caracteres",
      (val?: string | null) => !val || validateSeoTitle(val)
    ),
  seo_short_description_es_property: string()
    .default("")
    .label("Descripción corta SEO en español"),
  // .required("La descripción corta SEO en español es requerida")
  // .max(
  //   161,
  //   "La descripción corta SEO en español debe tener máximo 160 caracteres"
  // )

  seo_description_es_property: string()
    .default("")
    .label("Descripción SEO en español")
    .required("La descripción SEO en español es requerida")
    .test(
      "seo-description",
      "La descripción SEO en español debe tener entre 49-300 palabras y 200-2000 caracteres",
      (val?: string | null) => !val || validateSeoLongDescription(val)
    ),
  seo_keywords_es_property: array()
    .of(string().label("Palabras clave SEO en español"))
    .default([])
  // .min(1, "Debe agregar amenos una palabra clave")
  // .required("Las palabras clave SEO en español son requeridas")
};

export default seoStepSchema;
export type ISeoStepSchema = typeof seoStepSchema;
export const CSeoStepKeysArray = Object.keys(
  seoStepSchema
) as (keyof ISeoStepSchema)[];
